import Vue from 'vue'
import Navi from '../navi/index.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: h => h(Navi)
  }).$mount('#destination-submenu-container')
})